import React from 'react';
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TypedMemo } from '../../../common/types';

interface AuthFieldErrorProps {
  id?: string;
  tone?: 'err' | 'ok';
  icon?: React.ComponentProps<typeof FontAwesomeIcon>['icon'];
}

/** One alert line of the auth screen (design: onboarding g6, the `.al` lines). */
const AuthFieldErrorComponent: React.FC<React.PropsWithChildren<AuthFieldErrorProps>> = ({
  id,
  tone = 'err',
  icon = faCircleExclamation,
  children,
}) => (
  <div className={`au-al ${tone}`} id={id} role={tone === 'err' ? 'alert' : 'status'}>
    <FontAwesomeIcon icon={icon} />
    <span>{children}</span>
  </div>
);

export const AuthFieldError = TypedMemo(AuthFieldErrorComponent);
